// This is the list of all slideshows that will be registered on the
// website, don't forget to register your new slideshows in the list:
export default {
  list: [
    require('./vue-data-binding/vueDataBinding').default,
    require('./ast/ast').default,
    require('./promiseaplus/promiseaplus').default
  ]
}
